import { BoardMessage, MessageStatus } from "../messages";
import useSendBoardEvent, {
  BoardTransitionEvent,
  MachineGroup,
} from "./state-machine/sendBoardEvent";

export function useUpdateMessageStatus(
  message: BoardMessage,
  onError?: () => void,
  onSuccess?: () => void,
) {
  const { sendBoardEvent, loading } = useSendBoardEvent(onError, onSuccess);

  const updateMessageStatus = (status: MessageStatus) => {
    if (!loading) {
      void sendBoardEvent(message.board_id, {
        machine_group: MachineGroup.BOARD,
        model_id: message.board_id,
        event: BoardTransitionEvent.UPDATE_MESSAGE_STATUS,
        update: {
          message_id: message.id,
          message_status: status,
        },
      });
    }
  };

  return {
    updateMessageStatus,
    updatingMessageStatus: loading,
  };
}
